<div class="container-fluid">
    <div class="row justify-content-center">
        <div class="col-12 col-md-12  banner-home justify-content-center align-items-center " [style.background-image]="'url(' + bannerImageUrl + ')'">
            <div class="row col-10 ">
                <div class="col-12 ">
                    <h1>{{'home-tittle-1' | translate}}</h1>

                </div>
                <div class="col-12 " style="font-size: 1.5em">
                    <h3>{{'home-text-1' | translate}}</h3>
                </div>
                <div class="col-12 " style="font-size: 1.5em">
                    <h3>{{'home-text-2' | translate}}</h3>
                </div>
                <div class=" p-3">
                    <filter-search-job [isHome]="true"></filter-search-job>
                    <!-- <div class="row row-input-home ">
                        <div class="col-12 col-md-4 mb-2">
                         

                            <div class=" row  search-job-home justify-content-center"
                                style="border-radius: 5px 0 0 5px">
                                <div class="col-md-1 col-1  d-flex justify-content-center align-items-center">
                                    <i class="bi bi-briefcase"></i>
                                </div>
                                <div class="col-md-11  col-10 div-autocomplete-home "><input type="text"
                                        class="form-control " [formControl]="searchControl" matInput
                                        placeholder="{{'search-job-opening-home' | translate}}"
                                        [matAutocomplete]="auto">

                                    <mat-autocomplete class="autocomplete-home" #auto="matAutocomplete">
                                        <mat-option *ngFor="let item of filteredItems | async"
                                            (click)="selectItem(item)">
                                            {{ item }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                            </div>


                        </div>
                        <div class="col-12 col-md-4 mb-2" style="border-left: solid 1px #000;">
                            
                            <div class="row search-job-home">
                                <div class="col-md-1 col-1 d-flex justify-content-center align-items-center">
                                    <i class="bi bi-pin-map"></i>
                                </div>
                                <div class="col-md-11 col-10 div-autocomplete-home"><input class="form-control"
                                        type="text" [formControl]="locationSearchControl" matInput
                                        placeholder="{{'location' | translate}}" [matAutocomplete]="locationAuto">

                                    <mat-autocomplete class="autocomplete-home" #locationAuto="matAutocomplete">
                                        <mat-option *ngFor="let item of filteredLocationItems | async"
                                            (click)="selectLocationItem(item)">
                                            {{ item.entidad }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                            </div>

                        </div>
                        <div class="col-12 col-md-4 mb-2 search-job-home"
                            style="padding: 0;border-radius: 0 10px 10px 0;">
                            <input type="button" value="{{'search-job' | translate}}" class="btn-home btn-primary" />


                        </div>

                    </div> -->
                </div>
            </div>

        </div>
    </div>

    <section class="py-5  fade-in-up" #fadeElement>
      <div class="">
        <div class="row g-4 justify-content-center">
          <div class="col-md-4">
            <a href="https://youtube.com/shorts/8kcq5POZ3Ts?si=LxlNC8pIunsTlPAp" target="_blank" style="
            text-decoration: none;">
            <div class="brand-card p-4 text-center h-100 shadow-sm bg-white rounded-4">
              <!--<img src="/assets/img/home/Manpower/banner mp.png" alt="Imagen" class="img-fluid rounded-3 mb-3 brand-img" />-->
              <img src="/assets/img/home/Manpower/4.jpg" alt="Imagen" class="img-fluid rounded-3 mb-3 brand-img" />
              <p class="text-muted"><strong>Tips de empleabilidad</strong></p>
              <p class="text-muted">{{ "brand-section-manpower-description" | translate }}</p>
            </div>
            </a>
          </div>
          <div class="col-md-4">
            <div class="brand-card p-4 text-center h-100 shadow-sm bg-white rounded-4">
              <img src="/assets/img/home/Manpower/banner mp.png" alt="Imagen" class="img-fluid rounded-3 mb-3 brand-img" />
              <img src="/assets/img/home/Manpower/mp logo.png" alt="Logo" class="mb-3" style="height: 32px;">
              <p class="text-muted">{{ "brand-section-manpower-description-2" | translate }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <a href="https://blog.manpowergroup.com.mx/tag/tu-nuevo-empleo" target="_blank" style="
            text-decoration: none;">
            <div class="brand-card p-4 text-center h-100 shadow-sm bg-white rounded-4">
              <!--<img src="/assets/img/home/TS/banners TS.png" alt="Imagen" class="img-fluid rounded-3 mb-3 brand-img" />-->
              <img src="/assets/img/home/Manpower/6.jpg" alt="Imagen" class="img-fluid rounded-3 mb-3 brand-img" />
              <p class="text-muted"><strong>Blog</strong></p>
              <p class="text-muted">{{ "brand-section-manpower-description-3" | translate }}</p>
            </div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <div class="separator-line"></div>

    <!-- <div class="container-fluid">
        <div class="row justify-content-center marcas-content">
            <div class="col-12 col-sm-12 col-md-4">
                <div class="card">
                    <div class="card-title">
                        <img src="/assets/img/home/Manpower/banner mp.png" class="img-superior">
                    </div>
                    <div class="card-body">
                        <img src="/assets/img/home/Manpower/mp logo.png" class="logo-marca">
                        {{ "brand-section-manpower-description" | translate }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-4">
                <div class="card">
                    <div class="card-title">
                        <img src="/assets/img/home/Experis/banners job board-03.png" class="img-superior">
                    </div>
                    <div class="card-body">
                        <img src="/assets/img/home/Experis/banners job board-06.png" class="logo-marca">
                        {{ "brand-section-experis-description" | translate }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-4">
                <div class="card">
                    <div class="card-title">
                        <img src="/assets/img/home/TS/banners TS.png" class="img-superior">
                    </div>
                    <div class="card-body">
                        <img src="/assets/img/home/TS/Logo TS.png" class="logo-marca">
                        {{ "brand-section-talentsolutions-description" | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <!--div class="row col-12">
        <div class="content-home">
            <div class="col-12 col-md-12 col-lg-12 fade-in-up" #fadeElement>
                <h3>{{"top-job-openings" | translate}}</h3>
                <job-card [jobOpenings]="topJobs" [type]="JobCardType.Top" [showCarousel]="true"></job-card>
            </div>
        </div>
    </div-->

    <!--div class="separator-line"></div-->

    <div class="row">
        <!-- <div class="justify-content-center content-home">
            <div class="col-10">
                <div class="row row-job-apply">
                    <div class="btn-group" role="group">
                        <ul class="nav-job-apply nav nav-pills">
                            <li class="nav-item">
                                <button type="button" class=" btn-tab-applies btn"
                                    [ngClass]="{ 'active': activeButton === 'remotebtn' }"
                                    (click)="changeJobOpening('remotebtn')"
                                    data-bs-toggle="button">{{"remote-job-openings"
                                    |
                                    translate}}</button>

                            </li>
                            <li class="nav-item">
                                <button type="button" class=" btn-tab-applies btn"
                                    [ngClass]="{ 'active': activeButton === 'todayjobbtn' }"
                                    (click)="changeJobOpening('todayjobbtn')"
                                    data-bs-toggle="button">{{"today-job-openings"
                                    |
                                    translate}}</button>

                            </li>
                            <li class="nav-item">
                                <button type="button" class=" btn-tab-applies btn"
                                    [ngClass]="{ 'active': activeButton === 'halftimejobbtn' }"
                                    (click)="changeJobOpening('halftimejobbtn')"
                                    data-bs-toggle="button">{{"halftime-job-openings" | translate}}</button>

                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> -->
        <!--div class="justify-content-center content-home fade-in-up" #fadeElement>
            <div class="col-12  col-md-12 col-lg-12">
                <h3 class="mb-4">{{"last-job-opening-tittle" | translate}} {{"last-job-opening-tittle-2" | translate}}</h3>
                <job-card [showCarousel]="false" [type]="JobCardType.Normal" [jobOpenings]="jobOpenings"></job-card>
            </div>
        </div-->
    </div>
</div>